export default __webpack_public_path__ + "static/media/ly.04c0c272.png";